import { Col, Row } from 'antd';
import { difference, intersection, map, union } from 'lodash-es';
import { FormattedMessage } from 'react-intl';

import { Spinner } from '../../../../components/data/Spinner';
import { FAIcon } from '../../../../components/adapters/fontAwesomeAdapters';
import TransferFormItem from '../../../../components/forms/Transfer';
import { useTransferStyles } from '../../../../components/forms/Transfer.styles';
import { useScrollbarsStyles } from '../../../../components/layout/Scrollbars.styles';
import AdminConsoleSection, {
  AdminConsoleSectionContent,
  AdminConsoleSectionTitleHeader,
} from '../../components/AdminConsoleSection';
import { formatAccountLabel } from '../../utils/adminFormatting';
import { AccountBusinessTypeField } from './AdminAccountDetailCommon';
import { useAdminAccountPickListCardStyles } from './AdminAccountPickListCard.styles';
import { useAdminAccountProfileCardStyles } from './AdminAccountProfileCard.styles';
import AdminAccountProfileButtons from './AdminAccountProfileButtons';

export const updateSelection = (value, direction, movedKeys) => {
  const movedDefault = intersection(value.default, movedKeys);
  const movedAll = difference(movedKeys, value.default);

  const newValues = { ...value };
  if (direction === 'left') {
    newValues.remove = union(value.remove, movedDefault);
    newValues.add = difference(value.add, movedAll);
  } else {
    newValues.add = union(movedAll, value.add);
    newValues.remove = difference(value.remove, movedDefault);
  }
  return newValues;
};

export const getTargetKeys = value =>
  union(difference(value?.default, value?.remove), value?.add);

const getTransferSections = (titlesPrefix, styles) => [
  {
    key: 'all',
    leftHeader: <FormattedMessage id={`${titlesPrefix}.types.library.full`} />,
    rightHeader: (
      <FormattedMessage id={`${titlesPrefix}.types.library.allowed`} />
    ),
    className: styles.transferSectionAutoHeight,
    scrollbarsConfig: {
      autoHeight: true,
      autoHeightMin: 0,
      autoHeightMax: '100%',
    },
  },
];

export default function AdminAccountPickListCard({
  account,
  viewMode,
  setViewMode,
  initialValues,
  visible,
  sectionHomeRoute,
  formToGraphql,
  section,
  data,
  loading,
}) {
  const { styles: scrollbarsStyles } = useScrollbarsStyles();
  const { styles: transferStyles } = useTransferStyles(scrollbarsStyles);
  const { styles } = useAdminAccountPickListCardStyles(transferStyles);
  const { styles: cardStyles } = useAdminAccountProfileCardStyles();

  if (!visible) {
    return null;
  }

  const { itemName, titleId, titlesPrefix, icon } = section;

  const dataSource = map(data, d => ({
    key: d.code,
    title: d.text,
  }));

  const getItemSection = () => 'all';

  const sections = getTransferSections(titlesPrefix, transferStyles);

  return (
    <div className={cardStyles.card}>
      <Row
        className={cardStyles.titleRow}
        align="middle"
        justify="space-between"
      >
        <Col>
          <div className={cardStyles.title}>
            <FAIcon icon={icon} className="icon-19" />
            <span>
              <FormattedMessage id={titleId} />
            </span>
          </div>
        </Col>
        <Col>
          <AdminAccountProfileButtons
            viewMode={viewMode}
            setViewMode={setViewMode}
            initialValues={initialValues}
            sectionHomeRoute={sectionHomeRoute}
            formToGraphql={formToGraphql}
          />
        </Col>
      </Row>

      <AdminConsoleSection>
        <AdminConsoleSectionTitleHeader>
          <span className={cardStyles.accountLabel}>
            {formatAccountLabel(account, { long: true })}
          </span>
          <AccountBusinessTypeField readOnly />
        </AdminConsoleSectionTitleHeader>
        <AdminConsoleSectionContent className={styles.transfer}>
          {loading ? (
            <Spinner />
          ) : (
            <TransferFormItem
              name={itemName}
              dataSource={dataSource}
              titles={[
                `${titlesPrefix}.types.source`,
                `${titlesPrefix}.types.allowed`,
              ]}
              updateSelection={updateSelection}
              getTargetKeys={getTargetKeys}
              transferSections={sections}
              getSection={getItemSection}
              floatingLabel={false}
            />
          )}
        </AdminConsoleSectionContent>
      </AdminConsoleSection>
    </div>
  );
}
